import { useEffect, useRef, useState } from 'react';

export const useResizeObserver = <T extends HTMLElement>() => {
  const [elementWidth, setElementWidth] = useState(0);
  const elementRef = useRef<T | null>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return undefined;

    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0]) {
        const { width: newWidth } = entries[0].contentRect;
        setElementWidth(newWidth);
      }
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return { width: elementWidth, elementRef };
};
